import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_report_alert_cta_clicked',
            props: {
                ...segmentProps,
                cta: '#context.cta',
                alert_type: '?#context.alertType',
                alert_sub_type: '?#context.alertSubType',
                report_state: '?#context.report_state',
                report_view_state: '?#context.report_view_state',
                user_state: '?#context.user_state',
            },
        },
    },
};
